import {useRef} from 'react';

import {Typography, VARIANTS} from '@/components/base/typography/Typography';
import {FAQ} from '@/components/common/faq/FAQ';
import {Section, SECTION_STYLES} from '@/components/common/section/Section';

import styles from './FaqSection.module.css';
import {questions} from './questions';

export function FaqSection() {
	const titleRef = useRef();

	return (
		<Section
			style={SECTION_STYLES.WITH_BREAKPOINTS}
			className={styles.section}
			isFullWidth
			classNameFW={styles.rootBg}
		>
			<Typography variant={VARIANTS.h1} className={styles.title} ref={titleRef}>
				FAQ
			</Typography>
			<FAQ
				className={styles.faq}
				questions={questions}
				questionClassName={styles.question}
				answerClassName={styles.answer}
				questionRootClassName={styles.questionRoot}
			/>
		</Section>
	);
}
